import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import HistoricoPedidoImportacao from "../classes/HistoricoImportacao";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  {
    method: "GET",
    rota: "HistoricoPedidoImportacao/RecuperarTodos",
  },
  { method: "POST", rota: "HistoricoPedidoImportacao/Adicionar" },
  { method: "PUT", rota: "HistoricoPedidoImportacao/Atualizar" },
  { method: "DELETE", rota: "HistoricoPedidoImportacao/Apagar" },
];

const cacheKey: string = "HistoricoPedidoImportacaoCache";
const cacheKeySelC: string = "HistoricoPedidoImportacaoSelecionado";

const apiServico: string = "PEDIDOS";

export default class HistoricoPedidoImportacaoDataset extends httpClient {
  constructor() {
    super(apiServico);
  }

  async getAll(): Promise<HistoricoPedidoImportacao[]> {
    let ok: boolean = false;
    let data: HistoricoPedidoImportacao[] = [];
    let error: any = undefined;
    await super
      .Get(calls[0].rota)
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
        data = HistoricoPedidoImportacao.fromJson(response.data);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<HistoricoPedidoImportacao[]>((resolve) => {
      resolve(data);
    });
  }

  async add(value: HistoricoPedidoImportacao) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .post(calls[1].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async update(values: object): Promise<boolean> {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .put(calls[2].rota, values)
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<boolean>((resolve) => {
      resolve(ok);
    });
  }

  async remove(value: HistoricoPedidoImportacao): Promise<boolean> {
    let ok: boolean = false;
    let error: any = undefined;
    await super
      .delete(calls[3].rota, HistoricoPedidoImportacao.toJson(value))
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<boolean>((resolve) => {
      resolve(ok);
    });
  }

  getKeyCache(): string {
    return cacheKey;
  }

  getKeyCacheSelected(): string {
    return cacheKeySelC;
  }

  getAllFromCache(): HistoricoPedidoImportacao[] {
    let result: HistoricoPedidoImportacao[] = JSON.parse(cacheKey);
    return result;
  }

  addResultsToCache(value: HistoricoPedidoImportacao[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  clearCache() {
    localStorage.removeItem(cacheKey);
  }

  clearSelectedItemFromCache() {
    localStorage.removeItem(cacheKeySelC);
  }
}
